import React from 'react';
import {useTranslation} from 'react-i18next';
import MobilePopup from '../../../../newPopup/mobilePopup/MobilePopup';
import SuccessTab from '../../successTab/SuccessTab';
import {convertVariablesToHtml} from '../../../../textEditor/Variables';
import {useVariables} from '../../../../../assets/objects/Variables';
import {SuccessContentProps} from '../types';

const SuccessContent = ({successShow, localTrialContacts, messageContent, onClose}: SuccessContentProps) => {
    const {t: tVariables} = useTranslation('variables');
    const {defaultVariables} = useVariables();
    const processedContent = convertVariablesToHtml(messageContent, defaultVariables, tVariables);

    if(!successShow.isOpen) return null;

    return (
        <MobilePopup
            close={onClose}
            showClass={successShow.showClass}
            title=""
            dataCyName="success-popup"
            list={undefined}
            forwardRef={undefined}
            TopComponent={null}
        >
            <SuccessTab
                currentTab="whatsapp"
                amount={localTrialContacts.length}
                messageContent={processedContent}
                close={onClose}
                trialRecipients={localTrialContacts}
            />
        </MobilePopup>
    );
};

export default SuccessContent;
